export default "__VITE_ASSET__IKYmhe8l__"